import { de } from 'vuetify/locale';
import designerI18n from './designer-i18n.js';

export default {
    welcome: "Willkommen",
    login: "Anmelden",
    logout: "Abmelden",
    about: "Über",
    dashboard: "Startseite",
    products: "Produkte",
    users: "Benutzer",
    labels: "Etiketten",
    createUser: "Benutzer anlegen",
    editUser: "Benutzer bearbeiten",
    deleteUser: "Benutzer löschen",
    userList: "Benutzerliste",
    productList: "Produktliste",
    createProduct: "Produkt anlegen",
    editProduct: "Produkt bearbeiten",
    deleteProduct: "Produkt löschen",
    labelSettings: "Etiketteneinstellungen",
    createCategory: "Kategorie anlegen",
    editCategory: "Kategorie bearbeiten",
    deleteCategory: "Kategorie löschen",
    categoryList: "Kategorieliste",
    dragToReorder: "Zum Umsortieren der Kategorien ziehen",
    name: "Name",
    nameFormat: "Name (Vorname Nachname)*",
    email: "E-Mail",
    emailFormat: "E-Mail*",
    role: "Ist Administrator",
    actions: "Aktionen",
    save: "Speichern",
    cancel: "Abbrechen",
    edit: "Bearbeiten",
    delete: "Löschen",
    confirmDelete: "Möchten Sie dieses Element wirklich löschen?",
    yes: "Ja",
    no: "Nein",
    search: "Suchen...",
    itemsPerPageText: "Einträge pro Seite:",
    pageText: "{0}-{1} von {2}",
    productName: "Produktname*",
    productNumber: "Produktnummer",
    productOnList: "Produktname",
    category: "Kategorie",
    categoryOnList: "Kategorie",
    categories: "Kategorien",
    noCategories: "Keine Kategorien",
    thawingDays: "Auftauen (Tage)",
    notesHint: "Zusätzliche Informationen zu diesem Produkt",
    refridgeDays: "Kühlschrank (Tage)",
    threeHoursHint: "Kann das Produkt 3 Stunden außerhalb stehen?",
    allergens: "Allergene",
    selectAllergens: "Allergene auswählen",
    noAllergens: "Keine Allergene",
    notes: "Notiz",
    daysUntilExpiration: "Tage bis zum Ablauf",
    daysNeededForThawing: "Benötigte Auftautage",
    daysInRefrigeration: "Tage im Kühlschrank",
    producedDateLabel: "Herstellungsdatum",
    openedDateLabel: "Öffnungsdatum",
    createdAt: "Erstellt am",
    updatedAt: "Aktualisiert am",
    expirationDate: "Ablaufdatum",
    openedDate: "Öffnungsdatum",
    producedDate: "Herstellungsdatum",     
    numLabels: "Anzahl Etiketten",
    quantity: "Menge",
    foodItems: "Produkte",
    printSelected: "Ausgewählte drucken",
    mandatoryField: "kennzeichnet ein Pflichtfeld",
    categoryName: "Kategoriename*",
    description: "Beschreibung",
    descriptionHint: "Zeilenumbruch mit Enter",
    standardCategory: "Standardkategorie",
    fieldRequired: "Feld ist erforderlich",
    standard: "Standard",
    devices: "Geräte",
    deviceNick: "Gerätename",
    deviceID: "Geräte-ID",
    confirmDeleteDevice: "Möchten Sie das Gerät wirklich löschen:",
    userAdministration: "Benutzerverwaltung",
    newPasswordOptional: "Neues Passwort (optional)",
    passwordFormat: "Passwort*",
    password: "Passwort",
    admin: "Administrator",
    printFooditems: "Etiketten drucken",
    fromFooditems: "aus Lebensmitteln",
    loadingHomepage: "Startseite wird geladen...",
    pleaseLogin: "Bitte melden Sie sich an, um die Startseite zu öffnen",
    settings: "Einstellungen",
    displaySettings: "Anzeigeeinstellungen",
    theme: "Design",
    light: "Hell",
    dark: "Dunkel",
    language: "Sprache",  
    selectLanguage: "Sprache wählen",
    finnish: "Finnisch",
    danish: "Dänisch",
    english: "Englisch",
    swedish: "Schwedisch",
    norweigian: "Norwegisch",
    german: "Deutsch",
    japaneese: "Japanisch",
    selectedLabel: "Ausgewähltes Etikett",
    dataManagement: "Datenverwaltung",
    importData: "Daten importieren",
    exportData: "Daten exportieren",
    importExport: "Import / Export",
    exportProducts: "Produkte exportieren",
    importProducts: "Produkte importieren",
    selectFile: "Datei wählen",
    upload: "Hochladen",
    download: "Herunterladen",
    dataImportSuccess: "Daten erfolgreich importiert",
    dataImportError: "Fehler beim Datenimport",
    importProductsSubtitle: "Produkte aus einer xlsx-Datei importieren.",
    useCategories: "Kategorien anzeigen",
    defaultLabel: "Standardetikett",
    defaultLabelHint: "Wählen Sie das Etikett, das beim Drucken vorausgewählt ist.",
    noLabelsAvailable: "Keine Etiketten verfügbar",
    copy: "Kopie",
    useAliasAsTitle: "Alias als Titel verwenden",
    useAliasAsTitleHint: "Das Feld 'Alias' statt 'Produktname' verwenden. Ist 'Alias' leer, wird 'Produktname' verwendet.",
    menus: "Menüs",
    locations: "Standorte",
    deleteSelected: "Ausgewählte löschen",
    confirmDeleteSelected: "Möchten Sie wirklich {count} Produkte löschen?",
    create: "Anlegen",
    createNewCategory: "Neue Kategorie anlegen",
    nutritionProfile: "Nährwertprofil",
    nutritionProfileHint: "Wird vom Nährwertelement auf Etiketten verwendet.",
    noNutritionProfiles: "Noch keine Nährwertprofile",
    days: "Tage",
    hours: "Stunden",
    alias: "Alias",
    barcode: "Barcode",

    // Label Designer
    labelDesigner: "Etiketten-Designer",
    saveLabel: "Etikett speichern",
    refresh: "Aktualisieren",
    selectLabel: "Etikett wählen",
    createNewLabel: "Neues Etikett anlegen",
    labelName: "Etikettenname",
    width: "Breite (mm)",
    height: "Höhe (mm)",
    titleFont: "Titelschrift (pt)",
    titleX: "Titel X (mm)",
    titleY: "Titel Y (mm)",
    active: "Aktiv",
    addField: "Feld hinzufügen",
    fieldType: "Feldtyp",
    labelText: "Feldtext",
    baseDate: "Basisdatum",
    offsetField: "Offset-Feld",
    databaseField: "Datenbankfeld",
    xPosition: "X-Position (mm)",
    yPosition: "Y-Position (mm)",
    fontSize: "Schriftgröße (pt)",
    qrSize: "QR-Code-Größe (mm)",
    preview: "Vorschau",
    sampleItemName: "Beispiel-Produktname",
    size: "Größe",
    scale: "Maßstab",
    fieldsCount: "Felder",
    newLabel: "Neues Etikett",
    newField: "Neues Feld",
    labelSaved: "Etikett gespeichert!",
    loadLabelsFailed: "Etiketten konnten nicht geladen werden",
    saveLabelFailed: "Etikett konnte nicht gespeichert werden",
    labelPrinting: "Etikettendruck",
    productsPerPage: "Einträge pro Seite",
    showAll: "Alle anzeigen",
    selectAtLeastOne: "Bitte wählen Sie mindestens einen Eintrag.",
    noLabelSelected: "Kein Etikett gewählt. Bitte wählen Sie eines in den Einstellungen.",
    labelColor: "Etikettenfarbe",
    creditZplImage: "ZPL-Bild-Plugin entwickelt von: ",
    fieldTypePrompt: "Eingabeaufforderung",
    promptDialogTitle: "Eingabe",

    // Label Type
    labelType: "Etikettentyp",
    labelTypeStandard: "Standard",
    labelTypeFreetext: "Freitext",
    freetextNotice: "Freitext-Etiketten sind leere Felder zur freien Eingabe auf dem Tablet. Es werden weder Produktname noch vordefinierte Felder angezeigt.",

    // Logo
    logo: "Logo",
    logoReplace: "Ersetzen",
    logoUpload: "Hochladen",
    logoRemove: "Entfernen",
    logoNoLogo: "Kein Logo hochgeladen. Fügen Sie eines hinzu, um es auf dem Etikett zu platzieren.",
    logoUploadTitle: "Logo hochladen",
    logoSelectFile: "PNG-Bild wählen",
    logoSelectFileHint: "Laden Sie das Bild bereits gedreht hoch, genau wie es gedruckt werden soll.",
    logoWidthOnLabel: "Breite auf dem Etikett (mm)",
    logoWidthHint: "Die Höhe wird automatisch berechnet",
    logoPrinterDpi: "Drucker-DPI",
    logoOriginal: "Original",
    logoTarget: "Ziel",
    logoBlackThreshold: "Schwarzschwelle",
    logoBlackThresholdHint: "Niedriger = nur dunkle Pixel werden schwarz. Höher = auch hellere Pixel werden schwarz.",
    logoPreviewOriginal: "Original",
    logoPreviewMono: "Monochrom (wie gedruckt)",
    logoApply: "Übernehmen",
    logoLoaded: "Logo geladen ({width}×{height}mm). Platzieren Sie es mit X/Y unten auf dem Etikett.",
    logoNotUploaded: "Noch kein Logo hochgeladen. Gehen Sie zu Etiketteneinstellungen → Logo, um eines hochzuladen.",
    logoUploaded: "Logo hochgeladen und konvertiert",
    logoUploadFailed: "Logo konnte nicht hochgeladen werden",
    logoProcessFailed: "Logo konnte nicht verarbeitet werden",
    logoInvalidDimensions: "Ungültige Abmessungen",
    logoNoFile: "Keine Datei ausgewählt",

    // Field Types (dropdown titles)
    fieldTypeDate: "Datum",
    fieldTypeDatePlus: "Datum + Tage",
    fieldTypeDatabase: "Datenbankfeld",
    fieldTypeQrcode: "QR-Code",
    fieldTypeBarcode: "Barcode (Code128)",
    fieldTypeLogo: "Logobild",
    fieldTypeValueOnly: "Nur Wert (frei platziert)",
    fieldTypeAllergensText: "Allergentext",
    fieldTypeStatic: "Statischer Text",
    fieldTypeDivider: "Trennlinie",

    // Value Only sub-types
    valueType: "Werttyp",
    valueTypeDate: "Datum",
    valueTypeDatePlus: "Datum + Tage",
    valueTypeDatabase: "Datenbankfeld",

    // Field position & size labels
    xMm: "X (mm)",
    yMm: "Y (mm)",
    rotation: "Drehung",

    // Separator & value position
    separator: "Trennzeichen",
    separatorHint: "Text zwischen Beschriftung und Wert. Leer lassen für kein Trennzeichen.",
    separatorPlaceholder: ": ",
    valueXMm: "Wert X (mm)",
    valueXHint: "Leer lassen, um hinter der Beschriftung zu platzieren",
    valueYMm: "Wert Y (mm)",
    valueYHint: "Leer lassen, um das Y der Beschriftung zu verwenden",
    valueFontSize: "Schriftgröße des Werts",
    valueFontSizeHint: "Leer lassen, um die Größe der Beschriftung zu verwenden",

    // Font style
    bold: "Fett",
    italic: "Kursiv",

    // Text alignment
    textAlignment: "Textausrichtung",
    alignLeft: "Links",
    alignCenter: "Zentriert",
    alignRight: "Rechts",

    // QR Code
    qrDataSource: "QR-Datenquelle",

    // Barcode
    barcodeDataSource: "Datenquelle",
    barcodeWidthMm: "Barcode-Breite (mm)",
    barcodeHeightMm: "Barcode-Höhe (mm)",
    barcodeDisplayValue: "Wert unter dem Barcode anzeigen",

    // Allergens text
    allergenSeparator: "Trennzeichen",
    allergenSeparatorHint: "Zeichen zwischen Allergennamen (z. B. ', ' oder ' / ')",

    // Divider
    dividerLineWidth: "Linienbreite (mm)",
    dividerLineWidthHint: "Breite der Trennlinie",
    dividerLineThickness: "Linienstärke (mm)",
    dividerLineThicknessHint: "Stärke der Linie",

    // Date Base
    
    // Database Fields
    fridgeValue: "Kühlschrankwert",
    fridgeValueHint: "z. B. VOR DEM ÖFFNEN",
    threeHours: "Drei Stunden (JA/NEIN)",
    itemName: "Produktname",
    
    // Offset Fields
    thawingDaysOffset: "Auftautage",
    refrigeratedDaysOffset: "Kühltage",
    expiryDays: "Haltbarkeit (Tage)",
    thawingHours: "Auftaustunden",
    refrigeratedHours: "Kühlstunden",
    expiryHours: "Haltbarkeit (Stunden)",
    showTime: "Uhrzeit anzeigen",
    
    // QR Data Fields
    itemId: "Produkt-ID",
    customUrl: "Benutzerdefinierte URL",
    customData: "Benutzerdefinierte Daten",

    // Snackbar / status messages
    labelSavedSuccess: "Etikett gespeichert",
    labelSaveFailed: "Etikett konnte nicht gespeichert werden",
    labelLoadFailed: "Etiketten konnten nicht geladen werden",
    labelLoadSingleFailed: "Etikett konnte nicht geladen werden",
    fieldOrderUpdated: "Feldreihenfolge aktualisiert",

    // Labels management view
    labelsDescription: "Verwalten Sie Ihre Etiketten — Details ansehen, aktivieren/deaktivieren oder löschen.",
    totalLabels: "Etiketten insgesamt",
    activeLabels: "Aktive Etiketten",
    inactiveLabels: "Inaktive Etiketten",
    labelsList: "Etiketten",
    searchLabels: "Etiketten durchsuchen...",
    dimensions: "Abmessungen",
    inactive: "Inaktiv",
    color: "Farbe",
    type: "Typ",
    freetext: "Freitext",
    viewLabel: "Etikett ansehen",
    noLabelsFound: "Keine Etiketten gefunden",
    createFirstLabel: "Erstellen Sie Ihr erstes Etikett",
    namePosition: "Position des Namens",
    fieldLabel: "Feldbezeichnung",
    position: "Position",
    noFields: "Keine Felder konfiguriert",
    hasLogo: "Logo hinzugefügt",
    status: "Status",
    editInDesigner: "Im Designer bearbeiten",
    confirmDeleteText: "Möchten Sie '{labelName}' wirklich löschen? Dies kann nicht rückgängig gemacht werden.",
    deleteWarning: "Alle zu diesem Etikett gehörenden Felder werden ebenfalls gelöscht.",
    labelActivated: "'{name}' ist jetzt aktiv",
    labelDeactivated: "'{name}' ist jetzt inaktiv",
    labelToggleError: "Status des Etiketts konnte nicht geändert werden",
    labelDeleted: "'{name}' wurde gelöscht",
    labelDeleteError: "Etikett konnte nicht gelöscht werden",
    close: "Schließen",
    deleteLabel: "Etikett löschen",

    // device management
    devicesDescription: "Verwalten Sie Ihre Geräte und Lizenzen.",
    totalLicenses: "Lizenzen insgesamt",
    usedLicenses: "Verwendete Lizenzen",
    availableLicenses: "Verfügbare Lizenzen",
    devicesList: "Geräte",
    searchDevices: "Geräte durchsuchen...",
    deleteDevice: "Gerät löschen",
    noDevicesFound: "Keine Geräte gefunden",
    noDevicesHint: "Geräte registrieren sich über die App.",
    deleteDeviceHint: "Das Gerät muss sich erneut registrieren, bevor es genutzt werden kann.",
    deviceDeleted: "'{name}' wurde gelöscht",
    deviceDeleteError: "Gerät konnte nicht gelöscht werden",
    canEdit: "Kann bearbeiten",
    cannotEdit: "Kann nicht bearbeiten",
    canEditProducts: "Bearbeitung",
    allowEditing: "Bearbeitung erlauben",
    disableEditing: "Bearbeitung deaktivieren",
    editingEnabled: "Bearbeitung aktiviert",
    editingDisabled: "Bearbeitung deaktiviert",
    selected: "ausgewählt",
    updateError: "Aktualisierung fehlgeschlagen",
    canDelete: "Kann löschen",
    cannotDelete: "Kann nicht löschen",
    canDeleteProducts: "Löschen",
    allowDeleting: "Löschen erlauben",
    disableDeleting: "Löschen deaktivieren",
    deletingEnabled: "Löschen aktiviert",
    deletingDisabled: "Löschen deaktiviert",
    editingDisabledCascade: "Bearbeitung deaktiviert — Löschen wurde ebenfalls deaktiviert",
    deletingEnabledCascade: "Löschen aktiviert — Bearbeitung wurde ebenfalls aktiviert",
    allowBackdating: "Rückdatierung erlauben",
    disallowBackdating: "Rückdatierung deaktivieren",
    backdatingEnabled: "Rückdatierung aktiviert",
    backdatingDisabled: "Rückdatierung deaktiviert",
    backdatingDisabledCascade: "Rückdatierung deaktiviert — Bearbeitung wurde ebenfalls deaktiviert",
    backdatingEnabledCascade: "Rückdatierung aktiviert — Bearbeitung wurde ebenfalls aktiviert",
    backdatingOff: "Rückdatierung deaktiviert",
    backdatingOn: "Rückdatierung aktiviert",
    maxBackdateDays: "Maximale Tage für Rückdatierung",
    maxBackdateDaysHint: "Legen Sie fest, wie viele Tage rückwirkend für Herstellungs-/Öffnungsdatum gewählt werden dürfen. 0 deaktiviert die Rückdatierung.",

    // Configurations Page
    configurations: "Konfigurationen",
    globalSettings: "Globale Einstellungen",
    globalSettingsHint: "Diese Einstellungen gelten für alle Tablets dieses Kontos. Beim Speichern wird die Version erhöht, sodass Tablets die neuen Einstellungen laden.",
    tabletFields: "Tablet-Felder",
    tabletFieldConfig: "Konfiguration der Tablet-Felder",
    tabletFieldConfigHint: "Legen Sie fest, welche Felder beim Anlegen oder Bearbeiten von Artikeln auf Tablets sichtbar sind.",
    tabletFieldConfigInfo: "Zum Umsortieren ziehen. Ausgeblendete Felder erscheinen nicht in Tablet-Dialogen. Pflichtfelder müssen vor dem Speichern ausgefüllt werden.",
    freetextLabels: "Freitext-Etiketten",
    freetextLabelsOverview: "Freitext-Etiketten",
    freetextLabelsHint: "Alle Freitext-Etiketten einschließlich lokaler Tablet-Etiketten. Lokale Etiketten sind nur auf dem erstellenden Gerät sichtbar.",
    noFreetextLabels: "Keine Freitext-Etiketten gefunden.",
    reassignToDevice: "Gerät zuweisen",
    reassignHint: "Wählen Sie ein Gerät, dem dieses Freitext-Etikett zugewiesen wird. Auf dem ursprünglichen Gerät ist es dann nicht mehr sichtbar.",
    labelsSelected: "{count} Etikett(en) ausgewählt",
    targetDevice: "Zielgerät",
    markAsLocal: "Als lokal markieren",
    reassign: "Zuweisen",
    moveToDevice: "Auf Gerät verschieben",
    removeFromAll: "Von allen Geräten entfernen",
    broadcastNewLabel: "Neues Etikett an mehrere Geräte senden",
    broadcastNew: "Neu anlegen",
    broadcast: "Veröffentlichen",
    freetextContent: "Freitext-Inhalt",
    selectAll: "Alle auswählen",
    deselectAll: "Auswahl aufheben",
    selectDevices: "Geräte auswählen",
    broadcastDevices: "An {count} senden",
    devicesSelected: "{count} Gerät(e) ausgewählt",
    pushToDevices: "An {count} Geräte senden",
    pushExistingHint: "Ein vorhandenes Etikett an mehrere Geräte senden.",
    activeBroadcasts: "Aktive Übertragungen",
    broadcastsHint: "Freitext-Etiketten, die derzeit an mehrere Geräte gesendet werden. Sie bleiben aktiv, bis sie manuell von allen Geräten entfernt oder einem einzelnen Gerät zugewiesen werden.",
    noBroadcasts: "Keine aktiven Übertragungen",
    valuesInDays: "Tage",
    valuesInHours: "Stunden",
    showAlias: "Alias anzeigen",
    showAliasHint: "Das Feld 'Alias' auf dem Tablet-Startbildschirm unter dem Produktnamen anzeigen.",
    showMenuTab: "Menü-Tab anzeigen",
    showMenuTabHint: "Das aktive Menü als Tab auf dem Tablet-Startbildschirm anzeigen",
    hideCategoryAll: "Kategorie 'Alle' ausblenden",
    hideCategoryAllHint: "Die Kategorie 'Alle' im Kategoriemenü auf Tablets ausblenden",

    // Global Settings Toggles
    useCategoriesHint: "Kategoriemenü auf Tablets und Kategorieauswahl beim Anlegen von Artikeln anzeigen",
    usePrintDialog: "Druckdialog anzeigen",
    usePrintDialogHint: "Vor dem Drucken auf Tablets einen Dialog zur Datumsauswahl anzeigen",
    showTimestampOnDates: "Uhrzeit bei Datumsangaben anzeigen",
    showTimestampOnDatesHint: "Zeitstempel SS:MM auf Datumsetiketten einfügen (z. B. 17/02/26 10:30)",
    showCategoryOnProduct: "Kategorie beim Produkt anzeigen",
    showCategoryOnProductHint: "Den Kategorienamen unter dem Produktnamen auf dem Tablet-Startbildschirm anzeigen",
    todaysDateInclusive: "Heutiges Datum eingeschlossen",
    todaysDateInclusiveHint: "Den heutigen Tag in die Ablaufberechnung einbeziehen (z. B. 3 Tage ab Montag = Mittwoch statt Donnerstag)",
    settingsVersionInfo: "Aktuelle Version",
    settingsVersionHint: "Tablets mit einer älteren Version laden die aktualisierten Einstellungen bei der nächsten Aktualisierung.",
    saveChanges: "Änderungen speichern",

    // Field Config Table
    fieldName: "Feld",
    customLabel: "Benutzerdefinierte Beschriftung",
    visible: "Sichtbar",
    required: "Erforderlich",

    // Freetext Table
    content: "Inhalt",
    device: "Einheit",
    scope: "Geltungsbereich",
    updated: "Aktualisiert",
    local: "Lokal",
    global: "Global",
    confirmDeleteFreetext: "Möchten Sie dieses Freitext-Etikett wirklich löschen?",
    freetextSizes: "Verfügbare Größen",
    freetextSizesHint: "Liste der verfügbaren Freitext-Größen.",
    createSize: "Größe anlegen",
    createFreetextSize: "Freitext-Größe anlegen",
    widthMm: "Breite (mm)",
    heightMm: "Höhe (mm)",
    freetextSizeWhiteHint: "Freitext-Etiketten werden weiß dargestellt",
    default: "Standard",
    setAsDefault: "Als Standard festlegen",
    cancelDefault: "Standard aufheben",

    // Location management
    locationName: "Standortname",
    assignUser: "Benutzer zuweisen",
    assignedUsers: "Zugewiesene Benutzer",
    noUsersAssigned: "Keine Benutzer zugewiesen",
    addUsers: "Benutzer hinzufügen",
    selectUsers: "Benutzer auswählen",
    assignProducts: "Produkte zuweisen",
    assignedProducts: "Zugewiesene Produkte",
    availableProducts: "Verfügbare Produkte",
    noProductsAssigned: "Keine Produkte zugewiesen",
    allProductsAssigned: "Alle Produkte zugewiesen",
    countryCode: "Ländercode",
    timezone: "Zeitzone",
    createdLocation: "Standort angelegt",
    editLocation: "Standort bearbeiten",
    totalLabelsPrinted: "Insgesamt gedruckte Etiketten",
    clickForBreakdown: "Für eine detaillierte Aufschlüsselung klicken",
    printStatsTitle: "Druckstatistik",
    noPrintEvents: "Für keinen Standort wurden Druckstatistiken gefunden",
    labelsPrintedTotal: "Etiketten insgesamt gedruckt",
    since: "seit",
    createLocation: "Standort anlegen",

    //Tickets System
    createTicket: "Ticket erstellen",
    ticketType: "Ticket-Typ",
    ticketTypeSale: "Vertrieb",
    ticketTypeSupport: "Support",
    ticketTypeBug: "Fehlerbericht",
    ticketTitle: "Titel",
    ticketDescriptionHint: "Beschreiben Sie Ihr Problem oder Anliegen ausführlich",
    ticketReporter: "Melder",
    ticketCreated: "Ticket erstellt",
    priority: "Priorität",
    priorityHint: "Leer lassen, damit das System anhand des Ticket-Inhalts entscheidet, oder manuell wählen",
    priorityAuto: "Automatisch",
    priorityLow: "Niedrig",
    priorityMedium: "Mittel",
    priorityHigh: "Hoch",
    priorityUrgent: "Dringend",
    submit: "Ticket absenden",
    tickets: "Tickets",
    orderAccessories: "Etiketten & Zubehör bestellen",
    ticketLogHint: "Liste der an Capture IT gesendeten Supportanfragen.",

    impersonation: {
        menuItem: "Als Kunde anmelden",
        title: "Als Kunde anmelden",
        subtitle: "Wählen Sie einen Kunden, um in dessen Konto zu arbeiten. Alles, was Sie tun, betrifft echte Daten.",
        search: "Nach Kunde, Kontonummer oder E-Mail suchen...",
        customer: "Kunde",
        lastPrint: "Zuletzt gedruckt",
        enter: "Betreten",
        noCustomers: "Keine Kunden gefunden",
        loadFailed: "Kundenliste konnte nicht geladen werden",
        confirmTitle: "Konto dieses Kunden betreten?",
        confirmText: "Sie öffnen gleich das Konto von {customer} mit den Rechten des dortigen Administrators.",
        confirmWarning: "Alles, was Sie tun, betrifft die echten Daten des Kunden. Die Sitzung wird protokolliert und läuft nach 2 Stunden automatisch ab.",
        bannerTitle: "Sie arbeiten im Konto von {customer}",
        bannerSubtitle: "Dahinter als Sie selbst angemeldet ({user})",
        stop: "Verlassen",
        actions: "Aktionen",
    },

    designer: {
        untitled: "Ohne Titel",
        noLabel: "Kein Etikett ausgewählt",
        saved: "Gespeichert",
        saveError: "Konnte nicht gespeichert werden",
        unsavedTitle: "Nicht gespeicherte Änderungen",
        unsavedConfirm: "Sie haben nicht gespeicherte Änderungen. Seite verlassen?",
        leaveAnyway: "Trotzdem verlassen",
        stay: "Bleiben",
        toggleGrid: "Raster umschalten",
        preview: "Vorschau",
        undo: "Rückgängig",
        redo: "Wiederholen",
        save: "Speichern",
        print: "Drucken",
        back: "Zurück",
    },
    fields: {
        productFields: "Produktfelder",
        productField: "Produktfeld",
        barcodes: "Barcodes",
        layout: "Layout",
        qrCode: "QR-Code",
        staticText: "Statischer Text",
        imageLogo: "Logobild",
        divider: "Trennlinie",
        productNumber: "Produktnummer",
        productName: "Produktname",
        description: "Beschreibung",
        costPrice: "Einkaufspreis",
        salesPrice: "Verkaufspreis",
        currency: "Währung",
    },
    common: {
        none: "Keine",
        save: "Speichern",
        cancel: "Abbrechen",
        delete: "Löschen",
        close: "Schließen",
        edit: "Bearbeiten",
        copy: "Kopieren",
        unsaved: "Nicht gespeicherte Änderungen",
        loading: "Wird geladen...",
        error: "Fehler",
        success: "Erfolg",
    },
    label: {
        name: "Etikettenname",
        width: "Breite (mm)",
        height: "Höhe (mm)",
        color: "Farbe",
        colour: "Farbe",
        type: "Typ",
        grid: "Raster",
        gridSize: "Rastergröße (mm)",
        active: "Aktiv",
        unit: "Einheit",
        mm: "mm",
        inch: "Zoll",
    },
    canvas: {
        grid: "Raster anzeigen",
        gridSize: "Rastergröße (mm)",
        layers: "Ebenen",
        noElements: "Keine Elemente",
    },
    importFromOld: "Aus dem alten System importieren",
    selectLabelsToImport: "Zu importierende Etiketten wählen",
    importHint: "Etiketten werden in das neue System importiert. Das Original bleibt erhalten.",
    importCount: "{n} Etikett(en) importieren",
    newDesign: "Neues Etikett",
    designs: "Etiketten",
    searchDesigns: "Etiketten durchsuchen...",
    totalDesigns: "Etiketten insgesamt",
    activeDesigns: "Aktive Etiketten",
    inactiveDesigns: "Inaktive Etiketten",
    designCreated: "Etikett erstellt",
    designCopied: "Etikett kopiert",
    designDeleted: "Etikett gelöscht",
    designsDeleted: "Etiketten gelöscht",
    deleteDesign: "Etikett löschen",
    deleteDesignConfirm: "Möchten Sie '{name}' wirklich löschen?",
    bulkDelete: "Ausgewählte löschen",
    bulkDeleteConfirm: "Möchten Sie wirklich {n} Etiketten löschen?",
    errorCreating: "Etikett konnte nicht erstellt werden",
    errorUpdating: "Etikett konnte nicht aktualisiert werden",
    errorCopying: "Etikett konnte nicht kopiert werden",
    errorDeleting: "Etikett konnte nicht gelöscht werden",
    errorLoading: "Etiketten konnten nicht geladen werden",
    importSuccess: "{n} Etikett(en) importiert",
    importError: "Fehler beim Import",
    labelsSubtitle: "Verwalten Sie Ihre Etiketten",
    roundExpiryDownToQuarter: "Ablaufzeit auf die nächste Viertelstunde abrunden",
    roundExpiryDownToQuarterHint: "Nur bei Haltbarkeit in Stunden. Ein Ablauf um 16:07 wird als 16:00 angezeigt — immer abgerundet, damit die Haltbarkeit nie überschritten wird",
    // Shown on the colour swatch in the product list when the
    // product prints with something other than its own label.
    labelInactiveFallback: "Das Etikett \"{label}\" ist inaktiv — es wird mit \"{fallback}\" gedruckt",
    labelMissingFallback: "Kein Etikett gewählt — es wird mit \"{fallback}\" gedruckt",

    // Bulk deletion of categories, including the "these still
    // contain products — move them where?" second step.
    confirmBulkDeleteCategories: "Ausgewählte Kategorien löschen?",
    bulkDeleteWarning: "Dies kann nicht rückgängig gemacht werden.",
    categoriesInUseTitle: "Kategorien werden noch verwendet",
    categoriesInUseText: "Diese Kategorien enthalten noch Produkte:",
    moveProductsTo: "Produkte verschieben nach",
    moveAndDelete: "Verschieben und löschen",
    noReassignTarget: "Alle Kategorien sind ausgewählt. Wählen Sie mindestens eine ab, um die Produkte dorthin zu verschieben.",
    categoriesDeleted: "Kategorien gelöscht",
    productsMoved: "Produkte verschoben",
    defaultCategorySkipped: "die Standardkategorie wurde übersprungen",
    bulkDeleteFailed: "Löschen fehlgeschlagen",

    totalLocations: "Standorte insgesamt",

    productImage: "Produktbild",
    chooseFromLibrary: "Aus Bibliothek wählen",
    changeImage: "Bild ändern",
    productImageHint: "Wird auf dem Tablet anstelle des Produktnamens angezeigt, wenn die Bildanzeige aktiviert ist",
    productImageLibrary: "Bildbibliothek",

    productImages: {
        libraryTitle: "Bildbibliothek",
        libraryHint: "Laden Sie alle Produktbilder auf einmal hoch und weisen Sie sie anschließend den Artikeln zu.",
        uploadButton: "Bilder hochladen",
        deleteSelected: "Ausgewählte löschen",
        uploadProgress: "Wird hochgeladen",
        alreadyInLibrary: "Bereits in der Bibliothek",
        noImages: "Noch keine Bilder",
        preview: "Vorschau",
        name: "Name",
        dimensions: "Maße",
        usedBy: "Verwendet von",
        uploaded: "Hochgeladen",
        uploadSummary: "{n} Bilder hochgeladen",
        uploadSummaryFailed: "{n} hochgeladen, {failed} fehlgeschlagen",
        uploadSummaryDuplicates: "{n} hochgeladen, {duplicates} als Duplikate übersprungen",
        imageRenamed: "Bild umbenannt",
        renameFailed: "Bild konnte nicht umbenannt werden",
        confirmDeleteImage: "Möchten Sie dieses Bild wirklich löschen?",
        deleteImageInUseWarning: "{n} Artikel verwenden dieses Bild und verlieren es.",
        imageDeleted: "Bild gelöscht",
        imageDeletedInUse: "Bild gelöscht — die Artikel, die es verwendet haben, haben jetzt kein Bild",
        deleteFailed: "Bild konnte nicht gelöscht werden",
        confirmBulkDelete: "Löschen bestätigen",
        confirmBulkDeleteText: "Möchten Sie wirklich {n} Bilder löschen?",
        selectedInUseWarning: "{n} der ausgewählten Bilder werden verwendet und gehen bei den betroffenen Artikeln verloren.",
        andMoreCount: "… und {n} weitere",
        deleteAll: "Alle löschen",
        imagesDeletedSummary: "{n} Bilder gelöscht",
        imagesDeletedMissing: "{n} Bilder gelöscht ({missing} nicht gefunden)",
        bulkDeleteFailed: "Bilder konnten nicht gelöscht werden",

        picker: {
            title: "Bild wählen",
            uploadNew: "Neue hochladen",
            search: "Bilder durchsuchen...",
            empty: "Es sind noch keine Bilder in der Bibliothek. Laden Sie welche hoch, um zu beginnen.",
            noMatch: "Keine Bilder entsprechen der Suche",
            removeImage: "Bild entfernen",
            uploadFailedCount: "{n} Bilder konnten nicht hochgeladen werden",
        },
    },
    showProductImages: "Produktbilder anzeigen",
    showProductImagesHint: "Produktbilder auf dem Tablet-Startbildschirm anzeigen.",
    showProductNames: "Produktnamen anzeigen",
    showProductNamesHint: "Produktnamen auf dem Tablet-Startbildschirm anzeigen.",

    productDisplayMode: "Produktanzeige",
    displayModeText: "Namen",
    displayModeImage: "Bilder",
    displayModeUser: "Wahl des Benutzers",
    mixed: "Gemischt",
    noDevicesUpdated: "Es wurden keine Geräte aktualisiert",
    customFields: "Benutzerdefinierte Felder",
    customFieldsHint: "Felder hinzufügen, um bestimmte Produktinformationen anzuzeigen",
    noCustomFields: "Keine benutzerdefinierten Felder",
    editField: "Feld bearbeiten",
    fieldLabelHint: "Beschriftung des Feldes",
    fieldPrefixHint: "Präfix des Feldes",
    fieldKeyFixedHint: "Schlüssel des Feldes (nicht änderbar)",
    deleteFields: "Felder löschen",
    deleteFieldsWarning: "Dies löscht die ausgewählten Felder dauerhaft",
    deactivateInsteadHint: "Statt zu löschen deaktivieren",
    fieldsDeleted: "Felder gelöscht",
    valuesRemoved: "Werte entfernt",
    storedValues: "Gespeicherte Werte",
    printedPrefix: "Gedrucktes Präfix",
    prefix: "Präfix",
    fieldKey: "Feldschlüssel",
    values: "Werte",
    sortOrder: "Sortierreihenfolge",
    labelRequired: "Beschriftung ist erforderlich",

    ...designerI18n.de,
}